export default __webpack_public_path__ + "static/media/PK.4479c917.svg";